import { getWxLoginRes, getWxQrcode } from "@/services";
import useRequest from "@/utils/useReq";
import { useLocalStorageState } from "ahooks";
import QRCode from "qrcode.react";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import styles from "../index.module.less";
import accountLocked from "./accountLocked";

function isExpired(time) {
  // 9分钟
  return Date.now() - time > 9 * 60 * 1000;
}

const pollingLoginRes = async (wxQrcodeData, onLogin, refresh, timeRef) => {
  // 避免多次调用产生多个轮询
  if (timeRef.current) {
    clearTimeout(timeRef.current);
  }

  timeRef.current = setTimeout(async () => {
    // tab隐藏时避免发请求浪费资源
    if (document.visibilityState == "hidden") {
      pollingLoginRes(wxQrcodeData, onLogin, refresh, timeRef);
      return;
    }

    // 实时取，避免另一个tab登录导致二维码过期失效
    // const wxQrcodeData = JSON.parse(
    //   localStorage.getItem("huaban_wx_login_cache_data") || "{}"
    // );

    if (wxQrcodeData.data) {
      if (isExpired(wxQrcodeData.time)) {
        refresh();
        return;
      }
      const res = await getWxLoginRes(wxQrcodeData.data.scene_str);
      // 账号冻结处理
      if (res.err === 403) {
        accountLocked(res);
        return;
      }

      if (Object.keys(res).length > 0) {
        onLogin(res);
      } else {
        pollingLoginRes(wxQrcodeData, onLogin, refresh, timeRef);
      }
    }
  }, 3000);
};

export const WxLogin = forwardRef(function WxLoginRaw(
  { size = 156, style, onLogin },
  ref
) {
  const timeRef = useRef(null);

  const [wxQrcodeData, setWxQrcodeData] = useLocalStorageState(
    "huaban_wx_login_cache_data",
    {
      defaultValue: {},
    }
  );
  const [err, setErr] = useState();

  const { refresh } = useRequest(async () => {
    if (!wxQrcodeData.data || isExpired(wxQrcodeData.time)) {
      const res = await getWxQrcode();
      if (res.err) {
        setErr("获取二维码失败, 请刷新页面重试");
        return false;
      }

      setErr(false);
      setWxQrcodeData({
        data: res,
        // 二维码 10分钟过期
        time: Date.now(),
      });
      return res;
    }
  });

  useImperativeHandle(ref, () => ({
    refresh: refresh,
  }));

  const loginCb = useCallback(
    (res) => {
      onLogin(res);
      setWxQrcodeData({});
    },
    [onLogin, setWxQrcodeData]
  );

  useEffect(() => {
    if (wxQrcodeData.data) {
      pollingLoginRes(wxQrcodeData, loginCb, refresh, timeRef);
      return () => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearTimeout(timeRef.current);
      };
    }
  }, [loginCb, onLogin, refresh, setWxQrcodeData, wxQrcodeData]);

  return (
    <div
      style={{
        ...style,
      }}
    >
      <div
        className={styles.qrcodeWrap}
        style={{
          width: size,
          height: size,
        }}
      >
        {err ? (
          <div className={styles.err}>
            <span>
              获取二维码失败,
              <br />
              请点击 <a onClick={refresh}>重试</a>
            </span>
          </div>
        ) : (
          wxQrcodeData.data && (
            <QRCode
              id="wx_login"
              value={wxQrcodeData.data.url}
              size={size} // 二维码的大小
              fgColor="#000000" // 二维码的颜色
              style={{ margin: "auto" }}
            />
          )
        )}
      </div>
    </div>
  );
});
